export default __webpack_public_path__ + "static/FS2S-InHub-192-257135f9da0f143dfc9c2806a9597526.jpg";